export default "__VITE_ASSET__Cg6p4mBF__"